import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/app/home/components/ArticlesCardList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/app/home/components/blogCard/SocialShare.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/components/DynamicText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/BlogDetails/ad@3x copy.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/BlogDetails/ad@3x.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/homePage/BlogSideBar/ellipsis.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/homePage/FeatureImage.webp");
